<mat-form-field
	[color]="color"
	[appearance]="appearance"
	[floatLabel]="floatLabel"
>
	<mat-label [innerHtml]="label"></mat-label>
	<input
		matInput
		readonly
		(focus)="picker.open()"
		[matDatepicker]="picker"
		[formControl]="_control"
		[placeholder]="placeholder"
		[required]="required"
		[matDatepickerFilter]="filterFn"
	/>
	<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
	<mat-datepicker
		#picker
		disabled="false"
		startView="multi-year"
		(yearSelected)="_chosenYearHandler($event)"
		(monthSelected)="_chosenMonthHandler($event, picker)"
	></mat-datepicker>
	<mat-hint [innerHtml]="hint ? hint : ''"></mat-hint>
	<mat-error [innerHtml]="error"></mat-error>
	<img *ngIf="valid && validImage" class="valid-tick" [src]="validImage" />
</mat-form-field>
